/* Flechas de los carruseles de producto. La rueda del ratón no mueve una pista
   horizontal, así que sin flechas en escritorio no hay forma de deslizar. */
(function () {
  function monta(carrusel) {
    var pista = carrusel.querySelector('[data-v2-pista]');
    var prev = carrusel.querySelector('[data-v2-prev]');
    var next = carrusel.querySelector('[data-v2-next]');
    if (!pista || !prev || !next) return;

    function paso() {
      var primera = pista.querySelector('[data-v2-paso]') || pista.firstElementChild;
      if (!primera) return pista.clientWidth;
      var estilo = window.getComputedStyle(pista);
      var hueco = parseFloat(estilo.columnGap || estilo.gap) || 0;
      return primera.getBoundingClientRect().width + hueco;
    }

    function pinta() {
      var margen = pista.scrollWidth - pista.clientWidth;
      var hay = margen > 2 && window.matchMedia('(min-width: 768px)').matches;
      prev.hidden = !hay || pista.scrollLeft <= 2;
      next.hidden = !hay || pista.scrollLeft >= margen - 2;
    }

    prev.addEventListener('click', function () { pista.scrollBy({ left: -paso(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { pista.scrollBy({ left: paso(), behavior: 'smooth' }); });
    pista.addEventListener('scroll', pinta, { passive: true });
    window.addEventListener('resize', pinta);
    pinta();
    // Las fotos llegan tarde y cambian el ancho de la pista
    window.addEventListener('load', pinta);
    setTimeout(pinta, 1200);
  }

  function init() { document.querySelectorAll('.v2-carrusel').forEach(monta); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
